import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";

const BAR_COLORS = [
  "#4472C4", "#ED7D31", "#A5A5A5", "#FFC000", "#5B9BD5",
  "#70AD47", "#FF0000", "#7030A0", "#00B0F0", "#FF6600",
];

function formatMonthLabel(ym) {
  if (!ym) return "";
  const [year, month] = ym.split("-");
  return new Date(parseInt(year), parseInt(month) - 1).toLocaleString("en", { month: "long", year: "numeric" });
}

export default function DashboardMerchandising({ data }) {
  if (!data || data.products.length === 0) return null;

  const chartData = data.products.map((p) => {
    const point = { name: p.name };
    data.months.forEach((m, i) => { point[m] = p.pcts[i] ?? 0; });
    return point;
  });

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h6 className="card-title mb-3">Monthly Merchandising</h6>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={chartData}
            margin={{ top: 10, right: 20, bottom: 120, left: 0 }}
            barCategoryGap="20%"
            barGap={2}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 10 }}
              angle={-45}
              textAnchor="end"
              interval={0}
            />
            <YAxis domain={[0, 100]} tick={{ fontSize: 11 }} width={36} />
            <Tooltip formatter={(v) => `${v}%`} />
            <Legend verticalAlign="top" />
            {data.months.map((m, i) => (
              <Bar
                key={m}
                dataKey={m}
                name={formatMonthLabel(m)}
                fill={BAR_COLORS[i % BAR_COLORS.length]}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
